<template>
  <table class="w-100 delivery-plan-works-table">
    <thead>
      <tr>
        <th>{{ i18n.global.t('pages.dailyReports.updateModal.workList.No') }}</th>
        <th>{{ i18n.global.t('pages.dailyReports.updateModal.workList.work') }}</th>
        <th>{{ i18n.global.t('pages.dailyReports.updateModal.workList.address') }}</th>
        <th>{{ i18n.global.t('pages.dailyReports.updateModal.workList.arrivalDateTime') }}</th>
        <th>{{ i18n.global.t('pages.dailyReports.updateModal.workList.departureDateTime') }}</th>
        <th>{{ i18n.global.t('pages.dailyReports.updateModal.workList.workTime') }}</th>
        <th>{{ i18n.global.t('pages.dailyReports.updateModal.workList.runningTime') }}</th>
        <th>{{ i18n.global.t('pages.dailyReports.updateModal.workList.runningDistance') }}</th>
        <th>{{ i18n.global.t('pages.dailyReports.updateModal.workList.loadingOrRefueling') }}</th>
        <th>{{ i18n.global.t('pages.dailyReports.updateModal.workList.edit') }}</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <template v-for="(item, index) in items" :key="'work-' + item.work+item.list_id" >
        <Row
          :index="index+1"
          :item="item"
          :isWorkEditing="isWorkEditing"
          :isWaitingForSave="isWaitingForSave"
          :deliveryPlan="deliveryPlan"
          :operationOffice="operationOffice"
          :updateAuthority="updateAuthority"
          :createSpotAuthority="createSpotAuthority"
          @removeRow="removeRow"
          @updateItem="updateItem"
          @setRefuelingAmount="setRefuelingAmount"
          :showFlash="showFlash"
        />
      </template>
    </tbody>
  </table>
</template>

<script setup>
import Row from "@/components/DailyReportUpdateModalParts/DailyReportWorkListRow.vue";
import { ref, computed } from "vue";
import i18n from '@/lang/i18n';

const props = defineProps({
  deliveryPlan: {},
  modelValue: [],
  dialogState: {
    type: Boolean,
    default: false,
  },
  updateAuthority: {
    type: Boolean,
    default: true,
  },
  showFlash: {
    type: Function,
  },
  operationOffice: {
    type: Object,
  },
  createSpotAuthority: {
    type: Boolean,
  },
});

const emits = defineEmits([
  'update:modelValue',
  'setRefuelingAmount'
]);

const hasError = ref(false);
const deleteItems = ref([]);

const isWorkEditing = computed(() => {
  return !!items.value.filter((item) => {
    return item.editing;
  })[0];
})

const isWaitingForSave = computed(() => {
  return !!items.value.filter((item) => {
    return item.waiting_for_save;
  })[0];
})

const items = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emits('update:modelValue', value)
  }
})

function removeRow(item) {
  clearErrors()
  const target = items.value.filter((i) => {
    return item.start_time == i.start_time &&
      item.work == i.work;
  })[0]
  const index = items.value.indexOf(target)
  item.adding = false
  if(item.work == 'stopping'){
    deleteItems.value.push({
      start_time: item.start_time,
      end_time: item.end_time,
    })
  }
  items.value.splice(index, 1)
  emits('update:modelValue', items.value);
}

function clearErrors() {
  hasError.value = false
}

function setRefuelingAmount() {
  emits('setRefuelingAmount')
}

function updateItem(item) {
  const target = items.value.filter((i) => {
    return item.start_time == i.start_time &&
      item.work == i.work;
  })[0]
  const index = items.value.indexOf(target)
  items.value[index] = item;
  emits('update:modelValue', items.value);
}

</script>

<style>
</style>
